import React from 'react';
import { ButtonProps } from 'antd/lib/button';
import CcCluster from '../../../services/models/CcCluster';
import { CmonJobInstanceCommand } from '../../../services/cmon/models/CmonJobInstance';
import ClusterBootstrapForm from './ClusterBootstrapForm';
import ButtonWithForm from '../../../common/General/ButtonWithForm';
import JobActionButton from '../../Jobs/JobActionButton';
import CcNode from '../../../services/models/CcNode';

export default ClusterBootstrapButton;

export type ClusterBootstrapButtonProps = ButtonProps & {
    cluster: CcCluster;
    children?: React.ReactNode;
    node?: CcNode;
    onSuccess?: () => void;
};

function ClusterBootstrapButton({
    cluster,
    children,
    node,
    onSuccess,
    ...rest
}: ClusterBootstrapButtonProps) {
    return (
        <ButtonWithForm
            button={
                <JobActionButton
                    command={CmonJobInstanceCommand.BOOTSTRAP_CLUSTER}
                    clusterId={cluster.clusterId}
                    critical={true}
                    {...rest}
                >
                    {children || 'Bootstrap cluster'}
                </JobActionButton>
            }
            form={
                <ClusterBootstrapForm
                    node={node}
                    cluster={cluster}
                    onSuccess={onSuccess}
                />
            }
        />
    );
}
